import { render } from "./Button5.vue?vue&type=template&id=49d18817"
import script from "./Button5.vue?vue&type=script&lang=js"
export * from "./Button5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__